<template>
    <div class="subcontainer">
         <taskform :ntask="ntask"  :loaded="loaded" v-on:saveTask="saveTaskClicked(ntask)" :customers="customersList" :workerItems="workerItems" :workersLoaded="workersLoaded" ref="taskform"></taskform>
        <div class="row" style="padding-bottom: 25px;"  v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)">
            <div class="col offset-s8 s4" style="text-align: end; ">
                <a v-on:click="addPlace()" class="waves-effect waves-light btn-large solidgreen btn" style="border-radius: 8px !important;">
                    {{$t('subplaces.add')}}
                </a>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th class="name" v-on:click="set_order('name')">
                        <span>{{$t('subplaces.name')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'name' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                            <input :id="'number'+customer_id" type="text" class="validate" v-model="namesearch">
                        </div>
                    </th>
                    <th class="last_inspected" v-on:click="set_order('last_inspected')">
                        <span>{{$t('subplaces.last_inspected')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'last_inspected' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th class="next_inspection" v-on:click="set_order('next_inspection')">
                        <span>{{$t('subplaces.planned_inspection')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'next_inspection' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s6">
                        </div>
                    </th>
                    <th class="status" v-on:click="set_order('status')">
                        <span>{{$t('subplaces.status')}}</span>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_down</i>
                        <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_up</i>
                        <div class="input-field col s12" style="padding-right: 15px;">
                            <selector v-model="status" :items="statuses" identifier="statuses"></selector>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(placeItem, index) in listItems">
                    <tr class="content" :class="placeItem.status == 'active' ? '' : 'grayed'">
                        <td>

                            <div><a  style="cursor: pointer;" v-on:click="goToPlace(placeItem.id)">{{!!placeItem.name ? placeItem.name :  (!!placeItem.displayedname ? placeItem.displayedname : $t('places.no_name')) }}</a></div>
                        </td>
                        <td>
                            <div>{{placeItem.last_inspected * 1000 | formatDate}}</div>
                        </td>
                        <td>
                            <div class="cursor-pointer" v-if="placeItem.next_inspection_task"  v-bind:class="{ 'overdue': placeItem.overdone }" v-on:click="showTask(placeItem.next_inspection_task)">{{placeItem.next_inspection * 1000 | formatDate}}</div>
                            <div v-bind:class="{ 'overdue': placeItem.overdone }" v-else-if="placeItem.status == 'active' && role != 'ddd_customer'">
                                <button class="btn btn-small green" v-on:click="planInspection(placeItem)">{{$t('menu.buttons.plan_inspection')}}</button>
                                <template v-if="placeItem.earliest_planned_inspection != null"><br/>({{placeItem.earliest_planned_inspection.format("D.M.YYYY")}})</template>
                            </div>
                        </td>
                        <td>
                            <div>{{placeItem.status == "active" ? $t('subplaces.status_active') : (placeItem.status == "suspended" ? $t('subplaces.status_suspended') : $t('subplaces.status_inactive'))}}</div>
                        </td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
export default {
    data: function() {
        return {
            order: 'asc',
            orderby: 'number',
            loaded: false,
            places: [],
            selectedTags: [],
            statuses: [
                { name: this.$t('subplaces.status_active'), value: 'active' },
                { name: this.$t('subplaces.status_inactive'), value: 'inactive' },
                { name: this.$t('subplaces.status_suspended'), value: 'suspended' }
            ],
            namesearch: "",
            lastInspectiondateRange: { startDate: moment().startOf('year').format(), endDate: moment().endOf('year').format() },
            nextInspectiondateRange: { startDate: moment().startOf('year').format(), endDate: moment().endOf('year').format() },
            ntask: undefined,
            instances: undefined,
            placesDict: {},
            workerItems: [],
            workersLoaded: false
        }
    },
    props: { customer_id: Number, role: String, extended_privileges: Boolean, customer: Object, status: {
        type: Array,
        default: function(){
            return ['active']
        }, 
    } },
    watch: {
        customer_id: function(newVal, oldVal) { // watch it
            this.loaded = false;
            this.fetch_places();
        }
    },
    created() {

    },
    mounted() {
        if(this.customer != null && this.customer.subitems){
            axios.get('/customers/'+this.customer_id + "/places/last.json")
            .then(response => {
                if(this.customer.subitems.timestamp >= response.data){
                    this.places = this.customer.subitems.places;
                    this.order = this.customer.subitems.order;
                    this.orderby = this.customer.subitems.orderby;
                    this.loaded = true;
                    this.$forceUpdate();
                    return;
                }else{
                    this.loaded = false;
                    this.fetch_places();
                }
            } )
        }else this.fetch_places();
    },
    methods: {
        fetch_places: function() {
            axios.get('/customers/' + this.customer_id + '/places.json').then(response => {
                this.places = response.data;
                for (var i in this.places) {
                    var place = this.places[i];
                    place.orders_groupped = _.keyBy(place.orders, 'dev_type_id');
                    if(moment(place.next_inspection * 1000).isSameOrAfter(moment(), 'day')){
                        place.overdone = false
                    }else{
                        place.overdone = true
                    }
                }
                if(this.customer != null){
                    this.customer.subitems =  {
                        places: this.places,
                        timestamp: _.now() / 1000,
                        order: this.order,
                        orderby: this.orderby,
                    }
                }
                this.loaded = true;
                this.places = response.data.map(p => {
                  p.overdone = !moment(p.next_inspection * 1000).isSameOrAfter(moment(), 'day')
                  return p
                })

                this.placesDict = _.keyBy(this.places, 'id')
                this.init_selectors();
            })
            var that = this;
            axios.get('/workers.json').then(response => {
                // that.workersTimestamp = ts
                    that.workers = response.data;
                    for (var i in that.workers) {
                        var item = that.workers[i];
                        if (item.active == true) {
                            that.workerItems.push({ value: item.id, name: item.name + " " + item.surname, symbol: item.symbol });
                        }
                    }
                that.workersLoaded = true;
            })

        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        init_selectors: function() {

        },
        goToPlace(place_id) {
            this.$router.push('/customers/'+this.customer_id+'/places/'+place_id);
        },
        addPlace() {
            this.$router.push('/customers/'+this.customer_id+'/places/new');
        },
        saveTaskClicked: async function(task) {
            await this.saveTask(task)
            if (this.instances != undefined) {
                if(!_.isUndefined(this.instances[0])) this.instances[0].close()
            }
        },
        saveTask: async function(task) {
            if(moment(task.startsAt).isAfter(task.endsAt)){
                return false;
            } 
            const formData = new FormData();
            formData.append('task[startsAt]', moment(task.startsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[endsAt]', moment(task.endsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[typeof]', task.typeof);
            formData.append('task[payment_method]', task.payment_method || "cash");
            formData.append('task[pricing]', task.pricing);
            if (task.routine) formData.append('task[routine]', true);
            formData.append('task[name]', task.name || "");
            formData.append('task[status]', task.status);
            formData.append('task[reconescance]', task.reconescance);
            formData.append('task[physical_mount]', task.physical_mount);
            formData.append('task[intervention_type_other]', task.intervention_type_other);
            formData.append('task[typeof_other]', task.typeof_other);
            if (_.isUndefined(task.worker_ids) == false) {
                for (var index in _.range(0, task.worker_ids.length)) {
                    var worker_id = task.worker_ids[index];
                    if(worker_id != -1){
                        formData.append('task[worker_ids][]', worker_id);
                    }
                }
            }
            if (_.isUndefined(task.photos) == false) {
                for (var index in _.range(0, task.photos.length)) {
                    formData.append('task[media_attributes][' + index + '][image]', task.photos[index].attachment);
                    if (task.photos[index].id) {
                        formData.append('task[media_attributes][' + index + '][id]', task.photos[index].id);
                    }
                    if (task.photos[index].destroy) {
                        formData.append('task[media_attributes][' + index + '][_destroy]', true);
                    }
                }
            }
            if (task.typeof == 'intervention') formData.append('task[intervention_type]', task.intervention_type);
            if(_.isUndefined(task.phone_number) == false){
                formData.append('task[phone_number]', task.phone_number);
            }
            if (task.routine == false && (task.typeof == 'other' || task.typeof == 'intervention')) {
                formData.append('task[address_attributes][name]', task.address.name);
                formData.append('task[address_attributes][street]', task.address.street);
                formData.append('task[address_attributes][city]', task.address.city);
                formData.append('task[address_attributes][postal_code]', task.address.postal_code);
            } else {
                formData.append('task[place_id]', task.place_id);
            }
            if (task.id) {
                var response = await axios.put('/tasks/' + task.id + '.json', formData)
                var task = _.cloneDeep(response.data)
            } else {
                var response = await axios.post('/tasks.json', formData)
                var task = _.cloneDeep(response.data)   
            }
            task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm')
            task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm')
            this.placesDict[task.place_id].next_inspection = moment(task.startsAt).unix()
            this.placesDict[task.place_id].next_inspection_task = task.id;
            this.$refs.taskform.saving = false;
        },
        planInspection: function(place){
            this.ntask = {
                typeof: 'inspection',
                status: 'no_date',
                place_id: place.id,
                routine: false,
                worker_ids: [],
                startsAt: moment().format('YYYY-MM-DDTHH:mm'),
                endsAt: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
                address: {
                    name: "",
                    street: "",
                    city: "",
                    postal_code: ""
                },
                phone_number: "",
                reconescance: "",
                photos: [],
                edit: true
            };
            var elems = document.querySelectorAll('.modal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
        showTask: async function(taskid){
          var resp = await axios.get("/tasks/"+taskid+".json")
          resp.data.edit = false
          this.ntask = resp.data
          var elems = document.querySelectorAll('.modal');
          this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
          if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        }
    },
    computed: {
        listItems() {
            var that = this;
            const range = moment.range(moment(this.lastInspectiondateRange.startDate), moment(this.lastInspectiondateRange.endDate));
            const next_range = moment.range(moment(this.nextInspectiondateRange.startDate), moment(this.nextInspectiondateRange.endDate));
            return _.filter(
                _.orderBy(this.places, this.orderby, this.order),
                function(item) {
                    return (_.includes(that.status, item.status) || that.status.length == 0) && item.name.toUpperCase().indexOf(that.namesearch.toUpperCase()) >= 0
                }
            );
        },
        customersList() {
            var groupos = _.groupBy(this.places, 'customer_id');
            var items = []
            for( var group_id in groupos){
                items.push({"id": group_id, "name": _.first(groupos[group_id]).customer_name, "status": "active", "places": groupos[group_id]})
            }
            return items;
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

.selectorignored select {
    display: block;
}

/*.maincontainer{
  margin: 33px;
}*/
thead {
    background-color: #DADADA;
    font-size: 15px;
}

thead th {
    font-weight: 300;
    padding-top: 5px;
    padding-bottom: 5px;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

.subcontainer {
    margin-left: 30px;
}

.content div {
    margin-left: 15px;
}

/deep/ .vue-daterange-picker>div {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    border-radius: 5px;
    margin-bottom: 8px;
}

/deep/ .reportrange-text {
    padding-left: 5px !important;
    padding-top: 7px !important;
    padding-bottom: 7px !important;
}

th span {
    padding-left: 5px;
}

a {
    color: black;
}

select {
    display: block;
}

.solidgreen {
    background-color: #00CC66;
}
.btn-large {
    border-radius: 8px;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
    line-height: 36px;
}
.grayed {
    color: #BEBBBB !important;
}
.grayed a{
    color: #BEBBBB !important;
}
.overdue {
    color: red;
}
</style>